import React, { useState, useEffect, useRef } from "react";
import { Card, Button, ProgressBar, Form, Container, Row, Col, Toast, ToastContainer, Spinner } from "react-bootstrap";
import BarcodeScannerComponent from "react-qr-barcode-scanner";

import { getAssetInfoApi, getValidateScanDataApi } from "../asset-list/asset-api";
import "./checking.css";
import close from "../../assets/svg/close-scan.svg";
import qr from "../../assets/svg/scan-qr.svg";
import blurImg from "../../assets/svg/blur-img.svg";
import { useLocation, useNavigate } from "react-router-dom";

export default function CheckingAsset() {
  const navigate = useNavigate();
  const [assetTag, setAssetTag] = useState("");

  const [isScannerActive, setIsScannerActive] = useState(false);
  const [displayMessage, setDisplayMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [stopStream, setStopStream] = useState(false);
  const [fieldError, setFieldError] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(null); // Tracks which button is loading: 'Validation', 'Checking', 'Daily entry'
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const handleError = (err) => {
    setErrorMessage("No QR code detected. Try again.");
  };
  const restartScanner = () => {
    setDisplayMessage("Restarting scanner...");
    setIsScannerActive(false);
    setTimeout(() => setIsScannerActive(true), 100);
    setErrorMessage(null);
  };

  const closeModal = () => {
    setStopStream(true);
    setIsScannerActive(false);
  };

  const handleScan = (result) => {
    if (result) {
      setStopStream(true);
      setIsScannerActive(false);
      setAssetTag(result.text);
      setErrorMessage(null); // clear previous scan error on success
    }
  };
  const validateScanData = async (qrTag, type) => {
    setFieldError(null);
    setDisplayMessage(null);

    if (!qrTag || qrTag.trim() === "") {
      setFieldError("The asset tag field is required.");
      return;
    }

    setIsLoading(type); // Set loading for the clicked button

    try {
      const response = await getAssetInfoApi(qrTag);
      if (response.data.success === true) {
        navigate("/checking-view", { state: { assetDetail: response.data.asset, type: type } });

        if (response.data.data?.available_status === true) {
          closeModal();
        } else {
          setDisplayMessage("Dock not available");
        }
      } else {
        if (response.data.error && response.data.error.asset_tag) {
          setFieldError(response.data.error.asset_tag[0]);
        }
        setSnackbarMessage(response.data.message || "An error occurred");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
      return response.data;
    } catch (err) {
      if (err.response?.data?.error?.asset_tag) {
        setFieldError(err.response.data.error.asset_tag[0]);
      }
      setSnackbarMessage(err.response?.data?.message || "An unexpected error occurred");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsLoading(null); // Clear loading state
    }
  };

  return (
    <div className="container-fluid px-0" style={{ overflowY: "auto", width: "100%", height: "100vh", background: "#F0F4F9", overflowX: "hidden" }}>
      <Row style={{ background: "#FFFFFF" }}>
        <Col sm={12} md={6} lg={4}>
          <div className="my-5" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <div className="qr-title">Scan QR code or Bar code</div>
            <div className="qr-sub-title">Place the QR code in the scanner area</div>
            <div className="my-3" style={{ width: "267px", textAlign: "center" }}>
              {isScannerActive === true ? (
                <div style={{ position: "relative" }}>
                  <BarcodeScannerComponent
                    className="qr-image-wrapper"
                    width={267}
                    onUpdate={(err, result) => {
                      if (result) handleScan(result);
                      else handleError(err);
                    }}
                    style={{
                      width: "267px",
                      height: "267px",
                      borderRadius: "16px",
                      overflow: "hidden",
                    }}
                    stopStream={stopStream}
                  />
                  <div
                    className="style-justify-center cursor-pointer"
                    onClick={() => {
                      closeModal();
                    }}
                    style={{ position: "absolute", bottom: "14px", right: "14px", width: "77px", height: "32px", borderRadius: "100px", background: "#000000", opacity: "60%" }}
                  >
                    <img src={close} alt="Close" /> <span className="ps-1 font13-500-FFFFFF">Close</span>
                  </div>
                </div>
              ) : (
                <div style={{ width: "267px", height: "267px", backgroundImage: `url(${blurImg})`, color: "#1E1E1E", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Button
                    className="scan-qr-btn"
                    onClick={() => {
                      setIsScannerActive(true);
                      setStopStream(false);
                      setErrorMessage(null);
                      setDisplayMessage(null);
                    }}
                  >
                    <img src={qr} alt="QR" className="pe-2" /> Scan QR code
                  </Button>
                </div>
              )}
              <div>{displayMessage}</div>
              {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
            </div>
          </div>
        </Col>
        <Col sm={12} md={6} lg={8}>
          <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ width: "400px" }}>
              <div className="qr-title">Manual checking</div>
              <div className="qr-sub-title">Enter asset reference number or ID to check information</div>
              <div className="mt-3" style={{ textAlign: "left" }}>
                <input
                  type="text"
                  placeholder="Enter tag"
                  className={`input-field w-100 ${fieldError ? "is-invalid" : ""}`}
                  value={assetTag}
                  onChange={(e) => {
                    setAssetTag(e.target.value);
                    if (fieldError) setFieldError(null);
                    if (errorMessage) setErrorMessage(null);
                  }}
                  style={{ borderColor: fieldError ? "#dc3545" : undefined }}
                />
                {fieldError && <span style={{ color: "#dc3545", fontSize: "12px", marginTop: "4px", display: "block" }}>{fieldError}</span>}
              </div>
              <div className="mt-3 style-justify-between">
                <Button
                  className="validation-btn"
                  onClick={() => {
                    validateScanData(assetTag, "Validation");
                  }}
                  disabled={isLoading !== null}
                >
                  {isLoading === "Validation" && <Spinner animation="border" size="sm" className="me-2" style={{ color: "inherit" }} />}
                  Validation
                </Button>
                <Button
                  className="checking-btn"
                  onClick={() => {
                    validateScanData(assetTag, "Checking");
                  }}
                  disabled={isLoading !== null}
                >
                  {isLoading === "Checking" && <Spinner animation="border" size="sm" className="me-2" style={{ color: "inherit" }} />}
                  Checking
                </Button>
                <Button
                  className="daily-entry-btn"
                  onClick={() => {
                    validateScanData(assetTag, "Daily entry");
                  }}
                  disabled={isLoading !== null}
                >
                  {isLoading === "Daily entry" && <Spinner animation="border" size="sm" className="me-2" style={{ color: "inherit" }} />}
                  Daily entry
                </Button>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* Snackbar Toast */}
      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body className="text-white">{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}
